/* eslint-disable import/order */
/* eslint-disable import/no-duplicates */
/* eslint-disable import/no-named-as-default */

import React, { FC } from 'react';
import { Empty, Space, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { Alert } from '~/components';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, useLocation } from 'react-router-dom';
import features from '~/constants/features';
import { useGetApplication } from '~/controllers/wizard';
import ServicesNavigation from '~/layouts/ServicesNavigation';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import paths from '~/pages/paths';
import { getStagePayload } from '~/utils/getStagePayload';
import servicesDetails from './servicesDetails';
import adminstrator from './administrator';
import selectServices from './selectServices';
import cardOrderDetails from './cardOrderDetails';
import { useGetDraft } from '~/controllers/draft';
import { Draft } from '~/types/Draft';
import { WarningCircleIcon } from '~/img';
import ApplicationCommonErrors from '~/components/views/ApplicationCommonErrors';
import { useAmendment } from '~/controllers/amendment';

const views: Record<string, React.ComponentType> = {
  servicesDetails,
  cardOrderDetails,
  adminstrator,
};

const Services: FC<void> = () => {
  const location = useLocation();
  const applicationQuery = useGetApplication();
  const globeState = useSelector((state: any) => state?.state);
  const { showStatusAlert, showProductSelection } = globeState;
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const servicesSteps = stagePayload?.steps.find((item) => item.view === 'services')?.steps;
  const { t } = useTranslation('fillApplication');
  const draftQuery = useGetDraft<Draft<'selectServices'>>();
  const { data } = draftQuery;
  const atLeastOneSelectedService =
    data?.selectServices?.initialProducts?.find((item: any) => item?.enabled) ||
    applicationQuery?.data?.payload?.selectServices;

  const { isAmendment, isProductLocked } = useAmendment();
  const initialProducts =
    data?.selectServices?.initialProducts ||
    applicationQuery?.data?.payload?.selectServices?.initialProducts ||
    [];
  const hasNewSelectedService = initialProducts.some(
    (item: any) => item?.enabled && !isProductLocked(item?.id),
  );
  const isSelectServicesContinueDisabled = isAmendment
    ? !hasNewSelectedService
    : !atLeastOneSelectedService;

  const formName = location.pathname.split('/')[location.pathname.split('/')?.length - 1];
  if (draftQuery.isLoading || applicationQuery.isLoading) return <Spin />;
  return (
    <>
      {!applicationQuery?.data?.payload?.selectServices ||
      (isAmendment && formName === 'selectServices') ||
      formName === 'services' ? (
        <WizardContent
          left={
            <LeftLayout>
              <ServicesNavigation applicationQuery={applicationQuery?.data?.payload} />
              <BottomLeftActions contactUsUrl={features.contactUsLinkWizardApplication} />
            </LeftLayout>
          }
          content={
            <>
              {servicesSteps?.[0] && paths.wizard.services === location.pathname && (
                <Redirect
                  exact
                  from={paths.wizard.services}
                  to={`${paths.wizard.services}/${servicesSteps?.[0].uiKey}`}
                />
              )}
              <Route
                key="selectServices"
                path={`${paths.wizard.services}/selectServices` as any as string}
                component={selectServices || Empty}
              />
            </>
          }
          right={
            <Space direction="vertical" size={15}>
              {showStatusAlert && formName === 'cardOrderDetails' && (
                <Alert
                  message={t('Cardholder(s) consent is/are pending')}
                  type="error"
                  icon={<WarningCircleIcon />}
                  showIcon
                />
              )}

              <WizardContinueButton
                id="selectServices_continueButton"
                formName="selectServices"
                disabled={isSelectServicesContinueDisabled}
              />
            </Space>
          }
        />
      ) : (
        <WizardContent
          left={
            <LeftLayout>
              <ServicesNavigation applicationQuery={applicationQuery?.data?.payload} />
              <BottomLeftActions contactUsUrl={features.contactUsLinkWizardApplication} />
            </LeftLayout>
          }
          content={
            <>
              {servicesSteps?.[1] && paths.wizard.services === location.pathname && (
                <Redirect
                  exact
                  from={paths.wizard.services}
                  to={`${paths.wizard.services}/${servicesSteps?.[1].uiKey}`}
                />
              )}
              {servicesSteps?.map((item) => {
                if (item.uiKey === 'selectServices') return null;
                return (
                  <Route
                    key={item.key}
                    path={`${paths.wizard.services}/${item.uiKey}` as any as string}
                    component={views[item.uiKey] || Empty}
                  />
                );
              })}
            </>
          }
          right={
            <Space direction="vertical" size={15}>
              {showStatusAlert && formName === 'cardOrderDetails' && (
                <Alert
                  message={t('Cardholder(s) consent is/are pending')}
                  type="error"
                  icon={<WarningCircleIcon />}
                  showIcon
                />
              )}
              {formName === 'servicesDetails' && showProductSelection && (
                <Alert
                  message={t('one product should be selected at least')}
                  type="error"
                  icon={<WarningCircleIcon />}
                  showIcon
                />
              )}
              <ApplicationCommonErrors />
              <WizardContinueButton
                id="servicesSteps_continueButton"
                formName={formName === 'adminstrator' ? location.pathname : formName}
              />
            </Space>
          }
        />
      )}
    </>
  );
};

export default Services;
